
import { useState } from "react";

export const useAuthMode = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [signupDisabled, setSignupDisabled] = useState(false);

  const handleToggleMode = () => {
    setIsSignUp(!isSignUp);
  };

  const resetAuthMode = () => {
    setIsSignUp(false);
    setSignupDisabled(false);
  };

  return {
    isSignUp,
    setIsSignUp,
    signupDisabled,
    setSignupDisabled,
    handleToggleMode,
    resetAuthMode
  };
};
